exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".inline-validation-message{font-size:14px;margin:.5em 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/common/InlineValidationMessage/index.scss
// module id = 1012
// module chunks = 0